import { useRef } from 'react';
import { classNames } from 'libs/react';
import { SidePanel } from './SidePanel';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './SidePanelStack.scss';
/**
 * @component SidePanelStack
 * @since 1.0.0
 */
export function SidePanelStack(props) {
    const { style, picto, title, active, activeIndex } = Object.assign({ active: false, activeIndex: 0, style: 'normal' }, props);
    const node = useRef(null);
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    function onClose() {
        if (props.onClose) {
            props.onClose();
        }
    }
    /**
     * @function onBack
     * @since 1.0.0
     * @hidden
     */
    function onBack() {
        if (props.onBack) {
            props.onBack();
        }
    }
    const className = classNames('side-panel-stack', 'side-panel-stack--' + style, { 'side-panel-stack--is-active': active }, 'dark-mode', props.className);
    return (React.createElement("div", { ref: node, className: className },
        React.createElement("div", { className: "side-panel-stack-head" },
            React.createElement("div", { className: "side-panel-stack-head-content" },
                activeIndex > 1 && (React.createElement("div", { className: "side-panel-stack-back" },
                    React.createElement(Button, { style: "picto", picto: "arrow-left", onPress: () => onBack() }))),
                picto && React.createElement(Icon, { className: "side-panel-stack-picto", value: picto }),
                title && React.createElement(Text, { className: "side-panel-stack-title", value: title })),
            React.createElement("div", { className: "side-panel-stack-close" },
                React.createElement(Button, { style: "picto", picto: "times", onPress: () => onClose() }))),
        React.createElement("div", { className: "side-panel-stack-body" },
            React.createElement("div", { className: "side-panel-stack-body-content" }, React.Children.map(props.children, (child, index) => (React.createElement(SidePanel, { active: activeIndex - 1 == index }, React.cloneElement(child))))))));
}
